import Modal from '../../../../shared/Modal'
import Button from '../../../../shared/Buttons/Button'

interface IProps {
  onSave: () => void
  onContinue: () => void
  onClose: () => void
}

const SaveConfirmModal = (props: IProps) => {
  return (
    <Modal onClose={props.onClose} size="lg">
      <div className="form">
        <h2 className="form-header" style={{ textAlign: 'center' }}>
          У вас остались несохраненные изменения
        </h2>
        <div className="form-footer">
          <Button onClick={props.onContinue}>Продолжить без сохранения</Button>
          <Button onClick={props.onSave}>Сохранить</Button>
        </div>
      </div>
    </Modal>
  )
}

export default SaveConfirmModal
